import axiosInstance from 'utils/axios';

const shareDevice = (
  device: string,
  name: string,
  email: string,
  okCallback: () => void,
  koCallback: (error: any) => void
) => {
  axiosInstance
    .post(`/api/v2/device/share`, {
      device,
      name,
      email
    })
    .then(okCallback)
    .catch(koCallback);
};

export default shareDevice;
